<template>
  <div class="my-pooq-content-body">
    <div
      v-if="device !== 'ios'"
      v-infinite-scroll="loadMore"
      class="mypooq-list"
      :infinite-scroll-distance="200"
      :infinite-scroll-throttle-delay="200"
    >
      <div class="coupon-register">
        <h4 class="mypooq-title">Wavve 쿠폰 등록</h4>
        <label for="coupon-register" class="a11y-hidden">쿠폰등록</label>
        <input
          id="coupon-register"
          type="text"
          placeholder="쿠폰번호를 입력해 주세요"
          :value="couponCode"
          @input="couponCode = $event.target.value"
          @keyup="checkCodeCount"
        />
        <p class="coupon-notice">
          쿠폰번호에 숫자 0,1은 없습니다. 영문자 O,I와 혼동하지 않도록
          유의해주세요.
        </p>
        <div class="coupon-exclamation">
          <button
            type="button"
            class="btn-coupon-exclamation"
            @click.prevent="toggleCouponNotice"
          >
            <span>쿠폰 등록 시 꼭 확인하세요!</span>
            <IconUp v-if="couponNoticeOpen" />
            <IconDown v-if="!couponNoticeOpen" />
          </button>
          <ul v-if="couponNoticeOpen" class="coupon-exclamation-list">
            <li v-for="(item, index) in notificationList" :key="index">
              <span v-html="item.replaceAll('\n', '<br>')"></span>
            </li>
          </ul>
        </div>
        <a
          href="#"
          :class="
            enableCouponRegisterButton ? 'register-link on' : 'register-link'
          "
          @click.prevent="executeCouponRegister"
        >
          <span>쿠폰 등록</span>
        </a>
      </div>
      <div class="select-box">
        <ul>
          <li
            :class="tabType === 'having' ? 'on' : ''"
            @click.prevent="() => changeTabType('having')"
          >
            보유 쿠폰
          </li>
          <li
            :class="tabType === 'used' ? 'on' : ''"
            @click.prevent="() => changeTabType('used')"
          >
            소진 쿠폰
          </li>
        </ul>
      </div>
      <my-pooq-empty-list
        v-if="showEmptyList"
        :info-text="getEmptyText()"
      ></my-pooq-empty-list>
      <ul v-if="!showEmptyList" class="coin-coupon-list">
        <li
          v-for="(coupon, index) in couponList"
          :key="'coupon_' + index"
          :class="coinCouponCalss(coupon.status)"
        >
          <span class="coin-coupon-info">
            <span class="coin-coupon-info-detail">
              <div v-if="coupon.status" class="badge-group">
                <span class="badge ui">이용중</span>
              </div>
              <span class="coin-coupon-title">{{ coupon.couponname }}</span>
              <span v-if="tabType === 'having'" class="end-date">
                <span>유효기간</span>
                <i class="icon-dotted"></i>
                <span>{{ coupon.enddate }}</span>
              </span>
              <span v-if="tabType === 'used'" class="reason">
                <span>{{ coupon.couponstate }}</span>
                <i class="icon-dotted"></i>
                <span>{{ coupon.enddate }}</span>
              </span>
              <span class="reason">
                <span>지급 사유</span>
                <i class="icon-dotted"></i>
                <span>{{ coupon.description }}</span>
              </span>
            </span>
          </span>
          <button
            v-if="coupon.usable === 'y' && coupon.coupontype === 'voucher'"
            type="button"
            class="link-coupon"
            @click.prevent="() => executeCouponUse(coupon.couponnumber)"
          >
            사용하기
          </button>
        </li>
      </ul>
    </div>
    <div v-if="device === 'ios'" class="mypooq-list">
      <my-pooq-empty-list
        info-text="코인 쿠폰 등록과 사용은<br>웨이브 홈페이지에서 이용 가능합니다."
      ></my-pooq-empty-list>
    </div>
    <PopupRegisterEmail
      v-if="isShowPopup"
      @on-click-back="closePopup"
      @on-click-close="closePopup"
      @on-click-submit="registerCoupon"
    />
  </div>
</template>

<script>
  import IconUp from '@/assets/svg/common/ic-up-p.svg'
  import IconDown from '@/assets/svg/common/ic-down-p.svg'
  import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
  import { commonErrorProcess, MyPooqService } from '@/common/api/api.service'
  import { get } from 'lodash'
  import { infiniteScroll } from '@/common/directives'
  import {
    MSG_MOVING_MYPOOQ_COIN,
    MSG_MYPOOQ_COUPON_COMPLETE,
    MSG_MYPOOQ_COUPON_NO_VALUE,
    MSG_VOUCHER_SNS_ALERT,
    SNS_TYPE_LIST,
  } from '@/common/constant'
  import {
    MSG_USING_COUPON_ALREADY,
    MSG_COUPON_IN_APP,
    MSG_COUPON_INVALID,
    MSG_COUPON_SERVER_ERROR,
    COUPON_NOTIFICATION_LIST,
  } from '@/common/util/coupon/const'
  import utils from '@/common/util/utils'
  import { getCouponCheckRegisterAction } from '@/common/requests/data-fetch/get-coupon-check-register-action'
  import { mapMutations } from 'vuex'
  import PopupRegisterEmail from '@/components/lnb/mypooq/popup/PopupRegisterEmail.vue'
  import { getCouponCheckUseAction } from '@/common/requests/data-fetch/get-coupon-check-use-action'
  import { REGISTER_ACTION_TYPE, USE_ACTION_TYPE } from '@/common/normalize'
  import { PATH_NAME_COUPON } from '@/common/router.const'

  const TAB_TYPE_HAVING = 'having'
  const TAB_TYPE_USED = 'used'

  export default {
    name: 'Coupon',
    components: {
      IconUp,
      IconDown,
      MyPooqEmptyList,
      PopupRegisterEmail,
    },
    directives: {
      infiniteScroll,
    },
    data() {
      return {
        showEmptyList: false,
        tabType: 'having',
        couponNoticeOpen: false,
        enableCouponRegisterButton: false,
        couponCode: '',
        typedCouponNumber: '',
        couponList: [],
        offset: 0,
        limit: 20,
        loading: false,
        device: utils.cookies.getDevice(),
        isShowPopup: false,
        notificationList: COUPON_NOTIFICATION_LIST,
      }
    },
    mounted() {
      window.addEventListener('message', this.postMessage)
    },
    beforeDestroy() {
      window.removeEventListener('message', this.postMessage)
    },
    methods: {
      ...mapMutations(['showLoadingProgress', 'hideLoadingProgress']),
      postMessage(e) {
        if (
          e.origin === location.origin &&
          e.data?.eventMessage === 'PaymentCoupon'
        ) {
          if (e.data.result === 'y') {
            this.setData()
            window.location.reload()
          }
        }
      },
      closePopup() {
        this.isShowPopup = false
        this.couponCode = ''
      },
      showPopupEmail() {
        this.isShowPopup = true
      },
      async showPopupPayment(couponNumber = '') {
        const ACTION_PATH = 'PaymentCoupon'
        const credential = utils.cookies.getCredential()
        const loginType = utils.cookies.userInfo('type')

        const returnUrl = `${window.location.protocol}//${window.location.hostname}/callback.html?action=${ACTION_PATH}`
        const callback = () => {
          if (this.device !== 'mobile') {
            try {
              const url = encodeURIComponent(
                `https://bill.wavve.com/${ACTION_PATH}?credential=${utils.cookies.getCredential()}&deviceTypeId=${this.device}&couponSerialNumber=${couponNumber}&returnUrl=${encodeURIComponent(returnUrl)}`,
              )
              location.href = `captvpooq://webview?url=${url}&external=y`
            } catch (error) {
              console.log(error)
            }
          } else {
            const popup = window.open(
              `https://bill.wavve.com/${ACTION_PATH}?credential=${encodeURIComponent(utils.cookies.getCredential())}&deviceTypeId=mobile&couponSerialNumber=${couponNumber}&returnUrl=${encodeURIComponent(returnUrl)}`,
              '_blank',
              'scrollbars=yes',
            )
            popup?.window.focus()
            this.$router.replace({ name: PATH_NAME_COUPON })
          }
        }

        if (credential === 'none') {
          window.location.href = `/member/login.html?referer=${encodeURIComponent(location.href)}`
          return
        }

        if (SNS_TYPE_LIST.indexOf(loginType) > -1) {
          if (await utils.asyncConfirm(MSG_VOUCHER_SNS_ALERT)) {
            callback()
          }
        } else {
          callback()
        }
      },
      async getActionType(callback) {
        if (!callback) {
          return undefined
        }

        this.showLoadingProgress()
        const { data, error } = await callback()
        const actionType = data?.actionType
        this.hideLoadingProgress()

        if (!actionType) {
          return this.throwError(error)
        }

        return actionType
      },

      throwError(error) {
        const serverErrorRegExp = /^500/gi
        this.couponCode = ''

        if (serverErrorRegExp.test(error?.data?.code)) {
          utils.alert(MSG_COUPON_SERVER_ERROR)
          return undefined
        }

        utils.alert(error?.data?.data?.message || MSG_COUPON_INVALID)
      },
      async executeCouponUse(couponNumber) {
        const actionType = await this.getActionType(() =>
          getCouponCheckUseAction({ couponNumber }),
        )

        const {
          SHOW_ALERT_INAPP,
          SHOW_ALERT_USE_PRODUCT,
          USE_COUPON,
          SHOW_POPUP_REGIST_RECURRING,
        } = USE_ACTION_TYPE

        switch (actionType) {
          case SHOW_ALERT_INAPP: {
            utils.alert(MSG_COUPON_IN_APP)
            break
          }

          case SHOW_ALERT_USE_PRODUCT: {
            utils.alert(MSG_USING_COUPON_ALREADY)
            break
          }

          case USE_COUPON: {
            this.useCoupon(couponNumber)
            break
          }

          case SHOW_POPUP_REGIST_RECURRING: {
            this.showPopupPayment(couponNumber)
            break
          }
        }
      },
      async executeCouponRegister() {
        this.typedCouponNumber = this.couponCode.trim()

        if (this.typedCouponNumber.length === 0) {
          utils.alert(MSG_MYPOOQ_COUPON_NO_VALUE)
          return
        }

        if (utils.cookies.getCredential() === 'none') {
          location.href = `/login?referer=${encodeURIComponent(location.pathname + location.search)}`
          return
        }

        const actionType = await this.getActionType(() =>
          getCouponCheckRegisterAction({
            couponNumber: this.typedCouponNumber,
          }),
        )

        const {
          SHOW_ALERT_INAPP,
          SHOW_POPUP_EMAIL_REGISTER_COUPON,
          REGISTER_COUPON,
        } = REGISTER_ACTION_TYPE

        switch (actionType) {
          case SHOW_ALERT_INAPP: {
            utils.alert(MSG_COUPON_IN_APP)
            break
          }

          case SHOW_POPUP_EMAIL_REGISTER_COUPON: {
            this.showPopupEmail()
            break
          }

          case REGISTER_COUPON: {
            this.registerCoupon()
            break
          }
        }
      },
      registerCoupon(email = '') {
        MyPooqService.myCouponRegister({
          couponnumber: this.typedCouponNumber,
          email,
        })
          .then(async ({ data }) => {
            if (data.coupontypeid === '3') {
              if (await utils.asyncConfirm(MSG_MOVING_MYPOOQ_COIN)) {
                this.$router.push('/mypooq/coin')
              } else {
                window.location.reload(true)
              }
            } else {
              utils.alert(MSG_MYPOOQ_COUPON_COMPLETE)
              window.location.reload(true)
            }
          })
          .catch(async (error) => {
            if (error.response && error.response.status === 550) {
              if (error.response.data.resultcode === '210') {
                const moveToLoginPage = await utils.asyncConfirm(
                  error.response.data.resultmessage,
                )
                if (moveToLoginPage) {
                  location.href = `/login?referer=${encodeURIComponent(location.pathname + location.search)}`
                }
              } else {
                commonErrorProcess(error)
              }
            }
          })
      },
      getEmptyText() {
        return `${this.tabType === TAB_TYPE_HAVING ? '보유' : '소진된'} 쿠폰이 없어요.`
      },
      changeTabType(type) {
        this.tabType = type
      },
      toggleCouponNotice() {
        this.couponNoticeOpen = !this.couponNoticeOpen
      },
      checkCodeCount(e) {
        const value = e.target.value
        this.enableCouponRegisterButton = !!(value && value.length > 0)
      },

      useCoupon(couponNumber) {
        MyPooqService.myCouponActivate({
          couponnumber: couponNumber,
        }).then(() => {
          this.$nextTick(() => {
            this.tabType = TAB_TYPE_USED
          })
        })
      },
      loadMore() {
        if (this.endOfList) return
        this.setData()
      },
      setData() {
        if (this.loading) return
        this.loading = true
        let api = null
        if (this.tabType === TAB_TYPE_HAVING) {
          api = MyPooqService.getMyCouponList({
            offset: this.offset,
            limit: this.limit,
            orderby: 'new',
            coupontype: 'all',
            status: 'y',
          })
        } else if (this.tabType === TAB_TYPE_USED) {
          api = MyPooqService.getMyCouponList({
            offset: this.offset,
            limit: this.limit,
            orderby: 'new',
            coupontype: 'all',
            status: 'n',
          })
        }
        api.then(({ data }) => {
          let resList = get(data, 'list', [])
          this.endOfList = resList.length === 0
          this.offset += this.limit
          this.showEmptyList =
            this.couponList.length === 0 && resList.length === 0
          this.couponList = this.couponList.concat(resList)
          this.loading = false
        })
      },
      coinCouponCalss(status) {
        return this.tabType === TAB_TYPE_USED && status !== '이용중'
          ? 'coin-coupon-used'
          : ''
      },
    },
    watch: {
      tabType() {
        this.couponList = []
        this.showEmptyList = false
        this.endOfList = false
        this.offset = 0
        this.$nextTick(() => {
          this.setData()
        })
      },
    },
  }
</script>

<style scoped>
  .mypooq-list {
    height: auto;
  }
  .coupon-exclamation-list li:before {
    content: '\B7';
    display: inline-block;
    width: 10px;
    color: #717171;
    text-align: center;
    vertical-align: top;
  }
  .coupon-exclamation-list li span {
    display: inline-block;
    width: calc(100% - 10px);
    font-size: 12px;
    line-height: 1.5em;
  }
  .coin-coupon-used {
    opacity: 0.6;
  }
  /*.coin-coupon-used span{*/
  /*  color: #717171*/
  /*}*/
  input:focus::-webkit-input-placeholder {
    /* WebKit browsers */
    color: transparent;
  }
  input:focus:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: transparent;
  }
  input:focus::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: transparent;
  }
  input:focus:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: transparent;
  }

  .coin-coupon-info svg {
    margin-bottom: 10px;
  }
</style>
